export function SearchInputBadge(props){
    if(props.searchInput != "" && props.showSearchInputBadge){
        return <><span class="badge bg-info">{props.searchInput}</span>
        <button class="btn-close" type="button" aria-label='Close' onClick={props.removeSearchInput} style={{fontSize: '10px', marginLeft: '2px'}}></button></>
    } else {
        return ""
    }
}